export default __webpack_public_path__ + "static/tub-collection-peanut-butter-front-bb7fb391e2c2e46ce51f8dbcc3d3e1b0.png";